import { SentryService } from './sentry.service';

export default angular
  .module('sfMobile.services.sentry', ['sfMobile.config.server'])
  .service('sentryService', SentryService).name;
